import React from 'react'

const useColumns = () => {
  const assetNameColumn = {
    Header: 'Asset Name',
    accessor: 'assetName',
    filterable: true
  }

  const clientNameColumn = {
    Header: 'Client Name',
    accessor: 'clientName',
    filterable: true
  }

  const statusColumn = {
    Header: 'Logicmonitor Status',
    accessor: 'id',
    filterable: true,
    width: 200,
    Cell: row => {
      const status = row.original.status
      let style = ''

      if (status == 'Monitored') style = 'bg-green-600 text-white'
      else if (status == 'Not Monitored') style = 'bg-red-600 text-white'
      else if (status == 'Disabled') style = 'bg-gray-600 text-white'
      else if (status == 'Not Configured') style = 'bg-black text-white'
      else if (status == 'Removed') style = 'bg-gray-400 text-white'
      else style = 'border-2 text-black'


      return (
        <div
          className={`flex items-center text-center font-medium justify-center
            uppercase text-xs rounded-full w-32 h-8 mx-auto ${style}`}
        >
          {status}
        </div>
      )
    }
  }

  return [
    assetNameColumn,
    clientNameColumn,
    statusColumn
  ]
}

export default useColumns
